import { render, staticRenderFns } from "./SoliciTelessaudeIcon.vue?vue&type=template&id=17db1730"
import script from "./SoliciTelessaudeIcon.vue?vue&type=script&lang=js"
export * from "./SoliciTelessaudeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports